<form [formGroup]="model" (ngSubmit)="aplicarFiltros()">
  <div class="row search-area">
    <div class="col-12 col-lg-4 search-field">
      <mat-form-field appearance="outline">
        <mat-label>Pesquisar</mat-label>
        <input matInput type="text" formControlName="pesquisa" placeholder="Pesquise por número do pedido ou origem" />
        <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-8 filter-container">
      <div class="local-field">
        <mat-form-field appearance="outline">
          <mat-label>Localização</mat-label>
          <mat-select formControlName="idLocalizacaoEstoque" (selectionChange)="aplicarFiltros()">
            <mat-option [value]="null">Todos</mat-option>
            @for (l of listaLocalizacaoEstoque; track l.idLocalizacaoEstoque) {
              <mat-option [value]="l.idLocalizacaoEstoque">{{ l.nome }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <button
        #periodoMenuTrigger="matMenuTrigger"
        mat-stroked-button
        type="button"
        class="btn-periodo"
        [matMenuTriggerFor]="periodoMenu"
        (menuOpened)="prepararPeriodoIntervalo()"
        [class.btn-periodo--ativo]="periodoSelecionado !== PeriodoEnum.SemFiltro">
        {{ periodoLabel }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu" (closed)="onPeriodoMenuClosed()">
        <div class="periodo-menu-content">
          <div>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.SemFiltro); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.SemFiltro">
              <span>sem filtro</span>
              @if (periodoSelecionado === PeriodoEnum.SemFiltro) {
                <mat-icon>check</mat-icon>
              }
            </button>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.Ultimos30Dias); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.Ultimos30Dias">
              <span>últimos 30 dias</span>
              @if (periodoSelecionado === PeriodoEnum.Ultimos30Dias) {
                <mat-icon>check</mat-icon>
              }
            </button>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.DoMes); aplicarPeriodo()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoMes">
              <span>do mês</span>
              @if (periodoSelecionado === PeriodoEnum.DoMes) {
                <mat-icon>check</mat-icon>
              }
            </button>
            <button
              type="button"
              class="periodo-menu-item"
              (click)="selecionarPeriodo(PeriodoEnum.DoIntervalo); $event.stopPropagation()"
              [class.periodo-item-selecionado]="periodoSelecionado === PeriodoEnum.DoIntervalo">
              <span>do intervalo</span>
              @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
                <mat-icon>check</mat-icon>
              }
            </button>

            @if (periodoSelecionado === PeriodoEnum.DoIntervalo) {
              <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline">
                  <mat-label>De</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerPeriodoDe"
                    [(ngModel)]="periodoIntervaloDe"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onPeriodoIntervaloChange('de', $event)"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onDateBlur($event, 'de')"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [max]="periodoIntervaloAte" />
                  <mat-datepicker-toggle matSuffix [for]="pickerPeriodoDe"></mat-datepicker-toggle>
                  <mat-datepicker #pickerPeriodoDe></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Até</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerPeriodoAte"
                    [(ngModel)]="periodoIntervaloAte"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onPeriodoIntervaloChange('ate', $event)"
                    (input)="onDateInput($event)"
                    (keydown)="onDateKeydown($event)"
                    (blur)="onDateBlur($event, 'ate')"
                    placeholder="DD/MM/AAAA"
                    inputmode="numeric"
                    maxlength="10"
                    [min]="periodoIntervaloDe" />
                  <mat-datepicker-toggle matSuffix [for]="pickerPeriodoAte"></mat-datepicker-toggle>
                  <mat-datepicker #pickerPeriodoAte></mat-datepicker>
                </mat-form-field>

                <div class="periodo-intervalo-actions">
                  <button
                    type="button"
                    mat-button
                    class="btn-secondary"
                    (click)="cancelarPeriodoIntervalo(periodoMenuTrigger)">
                    Cancelar
                  </button>
                  <button
                    type="button"
                    mat-flat-button
                    class="btn-primary"
                    (click)="aplicarPeriodo(periodoMenuTrigger)">
                    Aplicar
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </mat-menu>

      <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
        <mat-icon>cleaning_services</mat-icon>
        Limpar Filtros
      </button>
    </div>
  </div>
</form>

@if (_isLoading && _dataSource.data.length === 0) {
  <app-loading-box-default-list></app-loading-box-default-list>
} @else if (_dataSource.data.length === 0) {
  <app-empty-list [title]="'Nenhuma reserva encontrada'" [subTitle]="'Ajuste os filtros para refinar a busca'"></app-empty-list>
} @else {
  <div class="table-container desktop-view">
  <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef class="w-checkbox">
        <mat-checkbox (change)="$event ? toggleAll() : null"
                      [checked]="isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row" class="w-checkbox">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="dataHora">
      <th mat-header-cell *matHeaderCellDef class="w-datahora" mat-sort-header="dataHora">Data e hora</th>
      <td mat-cell *matCellDef="let row" class="w-datahora">{{ row.dataHora | date: 'dd/MM/yyyy HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="localizacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="localizacao">Local de estoque</th>
      <td mat-cell *matCellDef="let row">{{ row.localizacao || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="quantidade">
      <th mat-header-cell *matHeaderCellDef class="text-end w-quantidade" mat-sort-header="quantidade">Quantidade</th>
      <td mat-cell *matCellDef="let row" class="text-end w-quantidade">{{ row.quantidade | abnt:'quantidade' }}</td>
    </ng-container>

    <ng-container matColumnDef="origem">
      <th mat-header-cell *matHeaderCellDef class="text-center w-origem" mat-sort-header="origem">Origem</th>
      <td mat-cell *matCellDef="let row" class="text-center w-origem">
        <ng-container *ngTemplateOutlet="indicadorTpl; context: { $implicit: indicadorOrigem(row) }"></ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="loteSerie">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="loteSerie">Lote/Série</th>
      <td mat-cell *matCellDef="let row">{{ row.codigoLote || row.codigoSerie || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="validade">
      <th mat-header-cell *matHeaderCellDef class="w-validade" mat-sort-header="validade">Validade</th>
      <td mat-cell *matCellDef="let row" class="w-validade">
        {{ row.dataValidadeReserva ? (row.dataValidadeReserva | date: 'dd/MM/yyyy') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="observacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="observacao">Descrição</th>
      <td mat-cell *matCellDef="let row">
        <span class="texto-cortado" [matTooltip]="row.observacao" [matTooltipDisabled]="!row.observacao">
          {{ row.observacao || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="text-end w-actions">Ações</th>
      <td mat-cell *matCellDef="let row" class="text-end w-actions">
        <button mat-icon-button [matMenuTriggerFor]="menuRow" aria-label="Ações">
          <span class="material-symbols-outlined">more_horiz</span>
        </button>
        <mat-menu #menuRow="matMenu">
          <span matTooltip="Sem permissão para excluir reservas" [matTooltipDisabled]="podeExcluir">
            <button mat-menu-item [disabled]="!podeExcluir" (click)="excluirReserva(row)">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir</span>
            </button>
          </span>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  </div>

  <div class="mobile-view">
    @for (row of _dataSource.data; track $index) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(row)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              color="primary">
            </mat-checkbox>

            <div class="d-flex flex-column">
              <span class="text-bold">Reserva</span>
              <small>{{ row.dataHora | date: 'dd/MM/yyyy - HH:mm' }}</small>
            </div>
          </div>

          <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Ações">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>

          <mat-menu #menuMobile="matMenu">
            <span matTooltip="Sem permissão para excluir reservas" [matTooltipDisabled]="podeExcluir">
              <button mat-menu-item [disabled]="!podeExcluir" (click)="excluirReserva(row)">
                <span class="material-symbols-outlined">delete</span>
                <span>Excluir</span>
              </button>
            </span>
          </mat-menu>
        </div>

        <div class="card-body-mobile p-3">
          <div class="row">
            <div class="col-6 mb-2">
              <small class="d-block">Quantidade</small>
              <span class="text-bold">{{ row.quantidade | abnt:'quantidade' }}</span>
            </div>

            <div class="col-6 mb-2">
              <small class="d-block">Origem</small>
              <ng-container *ngTemplateOutlet="indicadorTpl; context: { $implicit: indicadorOrigem(row) }"></ng-container>
            </div>

            <div class="col-6 mb-2">
              <small class="d-block">Local de estoque</small>
              <span>{{ row.localizacao || '-' }}</span>
            </div>

            <div class="col-6 mb-2">
              <small class="d-block">Lote/Série</small>
              <span>{{ row.codigoLote || row.codigoSerie || '-' }}</span>
            </div>

            <div class="col-6 mb-2">
              <small class="d-block">Validade</small>
              <span>{{ row.dataValidadeReserva ? (row.dataValidadeReserva | date: 'dd/MM/yyyy') : '-' }}</span>
            </div>

            <div class="col-12 mb-2">
              <small class="d-block">Descrição</small>
              <span>{{ row.observacao || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="col-12 text-center">
    <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
      @if (_isLoading) {
        <mat-spinner [diameter]="20"></mat-spinner>
      } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
      }
    </button>
  </div>
}

<!-- Indicador da origem: botão quando o documento tem tela (abre em nova aba), senão só a letra. -->
<ng-template #indicadorTpl let-ind>
  @if (ind.rota) {
  <button type="button" class="indicador indicador-sm indicador-link" [style.--indicador-cor]="ind.cor"
    [matTooltip]="ind.rotulo" [attr.aria-label]="ind.rotulo" (click)="abrirDocumentoOrigem(ind.rota)">
    {{ ind.sigla }}
  </button>
  } @else {
  <span class="indicador indicador-sm" [style.--indicador-cor]="ind.cor" [matTooltip]="ind.rotulo"
    [attr.aria-label]="ind.rotulo">
    {{ ind.sigla }}
  </span>
  }
</ng-template>
